module.exports = __webpack_public_path__ + "img/20182.ac916609.png";